(function(window, undefined) {
    'use strict';

    var menuIconColorsObj = {
        iconStrokeColor    : "#8494A7",
        iconSolidColor     : "#8494A7",
        iconFillColor      : "#c5e0e4",
        iconStrokeColorAlt : "#6366f1"
    };

    // Active Menu Icon Color Config
    var menuActiveIconColorsObj = {
        iconStrokeColor    : "#158394",
        iconSolidColor     : "#158394",
        iconFillColor      : "#c5e0e4",
        iconStrokeColorAlt : "#6366f1"
    };

    /* Text Area Counter Set Start */

    $(".char-textarea").on("keyup", function (event) {
        checkTextAreaMaxLength(this, event)
        // to later change text color in dark layout
        $(this).addClass("active")
    })

    /*
    Checks the MaxLength of the Textarea
    -----------------------------------------------------
    @prerequisite:  textBox = textarea dom element
            e = textarea event
                    length = Max length of characters
    */
    function checkTextAreaMaxLength(textBox, e) {
        var maxLength = parseInt($(textBox).data("length"))

        if (!checkSpecialKeys(e)) {
            if (textBox.value.length < maxLength - 1)
                textBox.value = textBox.value.substring(0, maxLength)
        }
        $(".char-count").html(textBox.value.length)

        if (textBox.value.length > maxLength) {
            $(".counter-value").removeClass('bg-primary-500');
            $(".counter-value").addClass('bg-danger-500');
            $(".char-textarea").addClass("max-limit text-danger-500")
        } else {
            $(".counter-value").removeClass('bg-danger-500');
            $(".counter-value").addClass('bg-primary-500');
            $(".char-textarea").removeClass("max-limit text-danger-500")
        }

        return true
    }

    /*
    Checks if the keyCode pressed is inside special chars
    -------------------------------------------------------
    @prerequisite:  e = e.keyCode object for the key pressed
    */
    function checkSpecialKeys(e) {
        if (
            e.keyCode != 8 &&
            e.keyCode != 46 &&
            e.keyCode != 37 &&
            e.keyCode != 38 &&
            e.keyCode != 39 &&
            e.keyCode != 40
        )
            return false
        else return true
    }

    $(window).on('load', function () {
        $.each($(".menu-livicon"), function (i) {
            var $this = $(this),
                icon = $this.data("icon"),
                iconStyle = 'lines'

            $this.addLiviconEvo({
                name: icon,
                style: iconStyle,
                duration: 0.85,
                strokeWidth: "1.3px",
                eventOn: "none",
                strokeColor: menuIconColorsObj.iconStrokeColor,
                solidColor: menuIconColorsObj.iconSolidColor,
                fillColor: menuIconColorsObj.iconFillColor,
                strokeColorAlt: menuIconColorsObj.iconStrokeColorAlt,
                afterAdd: function () {
                    if (i === $(".main-menu-content .menu-livicon").length - 1) {
                        // When hover over any menu item, start animation and stop all other animation
                        $(".main-menu-content .nav-item a").on("mouseenter", function () {
                            if ($(".main-menu-content .menu-livicon").length) {
                                $(".main-menu-content .menu-livicon").stopLiviconEvo()
                                $(this)
                                    .find(".menu-livicon")
                                    .playLiviconEvo()
                            }
                        })
                    }
                }
            })
        });

        function updateLivicon(el) {
            el.updateLiviconEvo({
                strokeColor: menuActiveIconColorsObj.iconStrokeColor,
                solidColor: menuActiveIconColorsObj.iconSolidColor,
                fillColor: menuActiveIconColorsObj.iconFillColor,
                strokeColorAlt: menuActiveIconColorsObj.iconStrokeColorAlt
            })
        }

        // Update Active Menu item Icon with active color
        if ($(".nav-item.mm-active .menu-livicon").length) {
            updateLivicon($(".nav-item.mm-active .menu-livicon"))
        }

        // Update Active sidebar group menu icon with active ccolor
        if ($(".main-menu-content li.mm-active .menu-livicon").length) {
            updateLivicon(
                $(".main-menu-content li.mm-active .menu-livicon")
            )
        }

        var scrollTopBtn = document.getElementById("scrollTopBtn");

        scrollTopBtn.addEventListener("click", scrollTopFunction);

        window.onscroll = function () {
            scrollFunction()
        };

        function scrollFunction() {
            if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
                scrollTopBtn.style.display = "block";
            } else {
                scrollTopBtn.style.display = "none";
            }
        }

        function scrollTopFunction() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }
    });

})(window);
